import { createButton, createElement } from "./dom";

export class EndScreen {
  public readonly element = createElement("section", "screen overlay-screen hidden");
  private readonly title = createElement("h2");
  private readonly statistics = createElement("div", "end-statistics");

  public constructor(onRestart: () => void, onMenu: () => void) {
    const eyebrow = createElement("div", "eyebrow", "ПОСЛЕБОЕВОЙ ОТЧЁТ");
    const actions = createElement("nav", "menu-actions compact");
    actions.append(
      createButton("НАЧАТЬ ЗАНОВО", onRestart),
      createButton("ВЕРНУТЬСЯ В МЕНЮ", onMenu),
    );
    this.element.append(eyebrow, this.title, this.statistics, actions);
  }

  public showComplete(
    seconds: number,
    kills: number,
    totalKills: number,
    secrets: number,
    totalSecrets = 1,
  ): void {
    this.title.textContent = "ЭВАКУАЦИЯ ЗАВЕРШЕНА";
    this.statistics.innerHTML = `<span>ВРЕМЯ<strong>${formatTime(seconds)}</strong></span><span>ВРАГИ<strong>${kills} / ${totalKills}</strong></span><span>ТАЙНИКИ<strong>${secrets} / ${totalSecrets}</strong></span>`;
    this.element.classList.remove("hidden");
  }

  public showDeath(seconds: number, kills: number): void {
    this.title.textContent = "БИОСИГНАЛ ПОТЕРЯН";
    this.statistics.innerHTML = `<span>ПРОЖИТО<strong>${formatTime(seconds)}</strong></span><span>ВРАГОВ УНИЧТОЖЕНО<strong>${kills}</strong></span>`;
    this.element.classList.remove("hidden");
  }

  public hide(): void {
    this.element.classList.add("hidden");
  }
}

function formatTime(seconds: number): string {
  const minutes = Math.floor(seconds / 60);
  const remainder = Math.floor(seconds % 60);
  return `${minutes.toString().padStart(2, "0")}:${remainder.toString().padStart(2, "0")}`;
}
